import { getI18nJsonProp } from "@/shared/i18n/locales/getI18nJsonProp";
import base from "./base.json";
import shared from "./shared.json";
import overview from "./overview.json";
import users from "./users.json";
import services from "./services.json";
import invitations from "./invitations.json";
import settings from "./settings.json";

const widAccountManagement = {
  ...getI18nJsonProp(base, "widAccountManagement"),
  ...getI18nJsonProp(shared, "widAccountManagement"),
  ...getI18nJsonProp(overview, "widAccountManagement"),
  ...getI18nJsonProp(users, "widAccountManagement"),
  ...getI18nJsonProp(services, "widAccountManagement"),
  ...getI18nJsonProp(invitations, "widAccountManagement"),
  ...getI18nJsonProp(settings, "widAccountManagement"),
};

export default widAccountManagement;
